import { useContextState } from "../../../hooks/theme"

export const useStyles = (data?: { removeMargin?: boolean }) => {
    const { colors } = useContextState()
    return {
        container: ({ styleType }: { styleType: boolean | undefined }) => ({
            ...!styleType && {
                width: '100%',
            },
            display: 'flex',
            marginTop: !data?.removeMargin ? '-20px' : 0,
        }),
        buttons: {
            //display: 'flex',
            //gap: 2,
            padding: 1,
        },
        button: {
            color: colors.color4,
            width: '100%',
            minWidth: '110px',
            maxWidth: '200px',
            display: 'block'
        },
        buttonsFlex: {
            display: 'flex'
        },
        text: {
            fontZize: '14px',
            color: colors.color13,
            wordBreak: 'break-word',
            textAlign: 'left',
            width: '100%',
        }
    }
}
